import { useMutation, type UseMutationResult } from '@tanstack/react-query';

export type ClubEmailPreferencesRequestBody = {
    newsletterEmails: boolean;
    eventEmails: boolean;
    annualReportEmails: boolean;
    functionDiningEmails: boolean;
    researchEmails: boolean;
    mccPlusEmails: boolean;
    waitingListEmails: boolean;
}

const useClubEmailPreferencesMutation = (): UseMutationResult<UseMutationResult, unknown, ClubEmailPreferencesRequestBody> => {
    const endpoint = '/api/Members/current/clubemailpreferences';

    const mutation = useMutation({
        mutationFn: async(data: ClubEmailPreferencesRequestBody): Promise<UseMutationResult> => {
            const response = await fetch(endpoint, {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' },
            });

            if (!response.ok) {
                if (response.status === 400) {
                    const errorResponse = await response.json();
                    throw new Error(errorResponse.errorMessage?.[0] ?? 'Bad request');
                }

                throw new Error('Unable to submit form');
            }

            const responseData = await response.json();

            if (!responseData.isSuccess) {
                throw new Error(`Form submission failed: ${responseData.errorMessage?.[0] ?? 'Unknown error'}`);
            }

            return responseData.data;
        },
    });

    return mutation;
};

export default useClubEmailPreferencesMutation;
